import { FatcaCheckResponseType, rtaType } from '../../components/common/FatcaCheck.types';
import { RTA_CODES } from '../../components/dashboard/commercial/emandate/types';
import { UI_KEYS } from '../../components/dashboard/commercial/ExploreMFs/mf-helpers';
import { PaymentTypes } from '../../components/dashboard/commercial/ExploreMFs/types';
import { sortFunds } from '../../utils/search';
import {
    FETCH_FUND_TRANSACTION_DETAILS_SUCCESS,
    GET_INVESTOR_LATEST_DETAILS,
    GET_INVESTOR_LATEST_DETAILS_FAILED,
    GET_INVESTOR_LATEST_DETAILS_SUCCESS,
    RTA_SCHEME_DETAIL_SUCCESS,
    SAVE_CHEQUE_FILE,
} from '../types/commercialTransactions';
import { LOGOUT_SUCCESS, MOBILE_SESSION_FORCE_LOGOUT, MOBILE_SESSION_OUT } from '../types/login';
import {
    UPDATE_PURCHASE_INFO,
    GET_PURCHASE_DETAILS_SUCCESS,
    CLEAR_PURCHASE_INFO,
    SET_PURCHASE_INFO,
    GET_PURCHASE_SCHEME_DETAILS_SUCCESS,
    GET_MASTER_DATA_SUCCESS,
    SET_SCHEME_INFO,
    schemeType,
    SET_FOLIO_PURCHASE_TYPE,
    RESET_SCHEME_INFO,
    SET_SCHEME_PLAN,
    CLEAR_SCHEME_INFO,
    MasterDataType,
    GET_PURCHASE_SCHEME_DETAILS,
    GET_PURCHASE_SCHEME_DETAILS_FAILED,
    ResponseStatus,
    SET_EUIN_CHECKED,
    GET_MASTER_DATA,
    PENNY_DROP_SUCCESS,
    SET_SIP_OR_LUMPSUM,
    CLEAR_SIP_OR_LUMPSUM,
} from '../types/newPurchase';
import {
    AccountTypes,
    GET_FATCA_STATUS_SUCCESS,
    GET_KYC_VERIFIED,
    GET_KYC_VERIFIED_FAILED,
    GET_KYC_VERIFIED_SUCCESS,
    IsAllow,
    SET_KYC_REGISTRATION_POPUP,
} from '../types/portfolio';

const initPurchase: any = {
    defaultInit: true,
    investorName: '',
    income: '',
    investorPan: '',
    investorPekrn: '',
    dob: '',
    matchFlag: 'Y',
    address: {
        line1: '',
        line2: '',
        line3: '',
        state: '',
        pincode: '',
        country: '',
        city: '',
    },
    transactionSource: '',
    lastTransactedDateTime: '',
    mobile: '',
    email: '',
    dpid: '',
    taxStatus: '',
    modeOfHolding: 'SINGLE',
    occupation: '',
    kycStatus: '',
    guardian: {
        name: '',
        pan: '',
        dob: '',
    },
    nominees: [],
    nomineeInSoa: 'N',
    fatcaDetails: [
        {
            fatcaId: 'FH',
            placeOfBirth: '',
            addressType: '',
            aadhaarNo: '',
            countryOfBirth: '',
            countryCitizen: '',
            declaration: IsAllow.No,
            taxResidencyOtherthanIndia: IsAllow.No,
            taxResidency: [
                {
                    id: '',
                    countryTax: '',
                    taxId: '',
                    idType: '',
                    tinReason: '',
                },
            ],
            annualIncomeSlab: '',
            occupation: '',
            pepFlag: '',
            netWorth: '',
            netWorthDate: '',
            sourceOfWealth: '',
            sourceOfFunds: '',
            fatherName: '',
            spouseName: '',
            corporateServices: '',
        },
    ],
    bank: [
        {
            accountNo: '',
            accountType: '',
            name: '',
            branch: '',
            city: '',
            pincode: '',
            micr: '',
            ifsc: '',
            neftIfsc: '',
            default: 'Y',
        },
    ],
    nomineeFlag: false,
};

export const initialSchemeInfo: schemeType = {
    folio: '',
    isin: '',
    amount: '',
    distId: '',
    reInvest: '',
    itemNo: '',
    trxnDate: '',
    trxnTime: '',
    subBrokerARN: '',
    startDate: '',
    endDate: '',
    frequency: '',
    trxnType: '',
    euin: '',
    euinDeclarationFlag: '',
    maxSipTat: '',
    minSipTat: '',
    noOfInstallments: '',
    registrationAmount: '',
    registrationDate: '',
    userTrxnNo: '',
    riaCode: '',
    sipType: '',
    subDist: '',
    riaFlag: UI_KEYS.RIA_CODE,
};
const intiState: InitStateForPurchaseType = {
    schemeInfo: initialSchemeInfo,
    fundInfo: {},
    purchaseDetails: initPurchase,
    newSchemeDetails: { amc: '' },
    exploreSchemeData: [],
    masterData: {
        amcDetails: [],
        categories: [],
        riskCategories: [],
        fundSizes: [],
        unSortedAmcList: [],
    },
    schemePlan: '',
    folioPurchaseType: '',
    exploreSchemeDataStatus: ResponseStatus.NOT_INTIATED,
    masterDataApiStatus: ResponseStatus.NOT_INTIATED,
    apiPendingActions: [],
    kycVerified: { value: null },
    euinChecked: IsAllow.No,
    fatcaStatusData: null,
    newInvestorDetails: { ...initPurchase, defaultInit: false },
    pennyDropStatus: { nameMatchStatus: '' },
    kycRegistrationPopup: null,
    sipOrLumpsum: null,
};

export type ChequeFile = {
    name: String;
    format: String;
    content: String;
};

export type PennyDropStatus = {
    nameMatchStatus: String;
};

export type KycPopupType = {
    isin: string;
    amc: string;
};

export type InitStateForPurchaseType = {
    schemeInfo: schemeType;
    fundInfo: any;
    purchaseDetails: null | any;
    exploreSchemeData: any[];
    masterData: MasterDataType;
    schemePlan: any;
    newSchemeDetails: { amc: String };
    folioPurchaseType: any;
    euinChecked?: any;
    exploreSchemeDataStatus: ResponseStatus;
    masterDataApiStatus: ResponseStatus;
    apiPendingActions: string[];
    kycVerified: { value: null | IsAllow; message?: string; lastUsedPan?: string };
    fatcaStatusData: Array<rtaType> | null;
    newInvestorDetails: null | any;
    pennyDropStatus: PennyDropStatus;
    chequeFile?: ChequeFile | null;
    kycRegistrationPopup: KycPopupType | null;
    sipOrLumpsum: PaymentTypes | null;
};

type ResoneBody = InitStateForPurchaseType;

function newPurchase(
    state = intiState,
    action: { type: string; body: ResoneBody },
): InitStateForPurchaseType {
    switch (action.type) {
        case SET_EUIN_CHECKED: {
            return { ...state, euinChecked: action.body.euinChecked };
        }
        case LOGOUT_SUCCESS: {
            return intiState;
        }
        case GET_PURCHASE_DETAILS_SUCCESS: {
            const { body } = action;
            return { ...state, ...body };
        }
        case UPDATE_PURCHASE_INFO: {
            const { body } = action;
            return { ...state, purchaseDetails: { ...state.purchaseDetails, ...body } };
        }
        case SET_PURCHASE_INFO: {
            const { body } = action;
            return { ...state, purchaseDetails: { ...body } };
        }
        case CLEAR_PURCHASE_INFO: {
            return { ...state, purchaseDetails: null };
        }
        case GET_PURCHASE_SCHEME_DETAILS_SUCCESS: {
            const data: any = action.body || {};
            return {
                ...state,
                exploreSchemeData: sortFunds(data),
                exploreSchemeDataStatus: ResponseStatus.DONE,
            };
        }
        case GET_PURCHASE_SCHEME_DETAILS: {
            return { ...state, exploreSchemeDataStatus: ResponseStatus.PENDING };
        }
        case GET_PURCHASE_SCHEME_DETAILS_FAILED: {
            return { ...state, exploreSchemeDataStatus: ResponseStatus.FAILED };
        }
        case GET_MASTER_DATA: {
            return { ...state, masterDataApiStatus: ResponseStatus.PENDING };
        }
        case GET_MASTER_DATA_SUCCESS: {
            const data: any = action.body || {};
            const { riskCategories, amcDetails, ...rest }: MasterDataType = data;
            return {
                ...state,
                masterDataApiStatus: ResponseStatus.DONE,
                masterData: {
                    ...rest,
                    unSortedAmcList: [...amcDetails],
                    amcDetails: amcDetails.sort((a, b) =>
                        a.amcFullName.localeCompare(b.amcFullName),
                    ),
                    riskCategories: riskCategories.slice(3, 9),
                },
            };
        }
        case SET_SCHEME_INFO: {
            return {
                ...state,
                schemeInfo: action.body as any,
            };
        }
        case RESET_SCHEME_INFO: {
            return {
                ...state,
                schemeInfo: { ...initialSchemeInfo, folio: state.schemeInfo.folio },
            };
        }
        case CLEAR_SCHEME_INFO: {
            return {
                ...state,
                schemeInfo: { ...initialSchemeInfo },
                folioPurchaseType: intiState.folioPurchaseType,
            };
        }
        case SET_SCHEME_PLAN: {
            return { ...state, schemePlan: action.body };
        }
        case FETCH_FUND_TRANSACTION_DETAILS_SUCCESS: {
            const { body = {} } = action;
            return { ...state, fundInfo: body };
        }
        case SET_FOLIO_PURCHASE_TYPE: {
            return { ...state, folioPurchaseType: action.body };
        }
        case SET_SIP_OR_LUMPSUM: {
            return { ...state, sipOrLumpsum: action.body.sipOrLumpsum };
        }
        case CLEAR_SIP_OR_LUMPSUM: {
            return { ...state, sipOrLumpsum: null };
        }
        case GET_INVESTOR_LATEST_DETAILS_SUCCESS: {
            const { success = [] }: any = action.body || {};
            const data = success[0] || {};
            return {
                ...state,
                purchaseDetails: {
                    ...state.purchaseDetails,
                    ...data,
                    fatcaDetails: Object.keys(data.fatcaDetails || []).length
                        ? data.fatcaDetails
                        : state.purchaseDetails.fatcaDetails,
                    bank: Object.keys(data.bank || []).length
                        ? data.bank[0].accountType === AccountTypes.SAVINGS ||
                          data.bank[0].accountType === AccountTypes.CURRENT
                            ? data.bank.filter(({ default: _d }: any) => _d === IsAllow.YES)
                            : state.purchaseDetails.bank
                        : state.purchaseDetails.bank,
                    nominees: data.nominees?.length
                        ? data.nominees
                              .slice(0, 3)
                              .map(({ percent, address, ...nominee }: any) => ({
                                  ...nominee,
                                  percentage: percent,
                                  address1: address?.line1 || '',
                                  address2: address?.line2 || '',
                                  address3: address?.line3 || '',
                                  city: address?.city || '',
                                  pincode: address?.pincode || '',
                                  state: address?.state || '',
                                  country: address?.country || '',
                              }))
                        : state.purchaseDetails.nominees,
                },
                apiPendingActions: [
                    ...state.apiPendingActions.filter(
                        (action) => action !== GET_INVESTOR_LATEST_DETAILS,
                    ),
                ],
            };
        }
        case GET_INVESTOR_LATEST_DETAILS: {
            return {
                ...state,
                apiPendingActions: [...state.apiPendingActions, GET_INVESTOR_LATEST_DETAILS],
                purchaseDetails: { ...state.purchaseDetails, defaultInit: false },
            };
        }
        case GET_KYC_VERIFIED_SUCCESS: {
            const { success = {} }: any = action.body || {};
            const kycVerified = ['verified', 'kyc verified', 'in progress'].includes(
                success?.panStatus?.toLowerCase()?.trim(),
            );
            const needToRetry = success?.panStatus?.toLowerCase()?.trim().includes('retry');
            return {
                ...state,
                apiPendingActions: [
                    ...state.apiPendingActions.filter((action) => action !== GET_KYC_VERIFIED),
                ],
                kycVerified: {
                    value: kycVerified ? IsAllow.YES : needToRetry ? null : IsAllow.No,
                    message: success?.panStatus,
                    lastUsedPan: (action.body as any).pan,
                },
            };
        }
        case SET_KYC_REGISTRATION_POPUP: {
            const { kycRegistrationPopup }: any = action.body || {};
            return {
                ...state,
                kycRegistrationPopup,
            };
        }
        case GET_KYC_VERIFIED: {
            return {
                ...state,
                apiPendingActions: [...state.apiPendingActions, action.type],
            };
        }
        case GET_KYC_VERIFIED_FAILED: {
            return {
                ...state,
                apiPendingActions: [
                    ...state.apiPendingActions.filter((_action) => _action !== GET_KYC_VERIFIED),
                ],
            };
        }
        case GET_INVESTOR_LATEST_DETAILS_FAILED: {
            return {
                ...state,
                apiPendingActions: [
                    ...state.apiPendingActions.filter(
                        (_action) => _action !== GET_INVESTOR_LATEST_DETAILS,
                    ),
                ],
            };
        }
        case GET_FATCA_STATUS_SUCCESS: {
            const { body }: any = action;
            let fatcaVerifyDetails = body.data || [];
            let defaultKfinFlag = false,
                defaultCamsFlag = false;
            fatcaVerifyDetails.forEach((fatca: any) => {
                if (fatca?.rtaName === RTA_CODES.KFIN) defaultKfinFlag = true;
                if (fatca?.rtaName === RTA_CODES.CAMS) defaultCamsFlag = true;
            });
            if (!defaultKfinFlag)
                fatcaVerifyDetails.push({ rtaName: RTA_CODES.KFIN, fhFatcaStatus: IsAllow.No });
            if (!defaultCamsFlag)
                fatcaVerifyDetails.push({ rtaName: RTA_CODES.CAMS, fhFatcaStatus: IsAllow.No });
            return {
                ...state,
                fatcaStatusData: fatcaVerifyDetails,
            };
        }
        case PENNY_DROP_SUCCESS: {
            const data: any = action.body || {};
            console.log('penny drop response = == ', data);
            return {
                ...state,
                pennyDropStatus: {
                    nameMatchStatus: data?.data?.[0].nameMatchStatus || 'N',
                },
            };
        }
        case SAVE_CHEQUE_FILE: {
            const { chequeFile } = action.body;
            return {
                ...state,
                chequeFile,
            };
        }
        case RTA_SCHEME_DETAIL_SUCCESS: {
            const { data } = action.body as any;
            return {
                ...state,
                newSchemeDetails: { amc: data?.[0].amc },
            };
        }

        case MOBILE_SESSION_OUT:
        case MOBILE_SESSION_FORCE_LOGOUT:
        case LOGOUT_SUCCESS: {
            return intiState;
        }
        default:
            return state;
    }
}

export default newPurchase;
